<div class="card-container mat-elevation-z1">
  <div class="card-content">
    <div *ngIf="!loading">
      <div class="card-box-medium margin-right-small">
        <h4>Identificación</h4>
        <mat-divider></mat-divider>
        <div class="card-inline margin-top-medium full-width">
          <h5>
            Protocolo: <b>{{ protocol }}</b>
          </h5>
        </div>
        <div class="card-inline margin-top-small full-width">
          <h5>
            Paciente: <b>{{ patientFullName }}</b>
          </h5>
        </div>
        <div class="card-inline margin-top-small full-width">
          <h5>
            Edad: <b>{{ patientAge }}</b>
          </h5>
        </div>
        <div class="card-inline margin-top-small full-width">
          <h5>
            Equipo: <b>{{ equipmentName }}</b>
          </h5>
        </div>
        <div *ngIf="diagnostic" class="card-inline margin-top-small full-width">
          <h5>
            Diagnóstico: <b>{{ diagnostic }}</b>
          </h5>
        </div>

        <div class="margin-top-medium">
          <table
            class="full-width"
            mat-table
            [dataSource]="dataSourcePrincipal"
          >
            <tr
              mat-header-row
              class="table-header"
              *matHeaderRowDef="displayColumnsPrincipal"
            ></tr>
            <tr
              class="table-cell"
              mat-row
              *matRowDef="
                let row;
                let i = index;
                columns: displayColumnsPrincipal
              "
            ></tr>
            <ng-container matColumnDef="PracticeRegionName">
              <th mat-header-cell class="table-header" *matHeaderCellDef>
                Práctica
              </th>
              <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.PracticeRegionName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="Quantity">
              <th mat-header-cell class="table-header" *matHeaderCellDef>
                Cantidad
              </th>
              <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.Quantity }}
              </td>
            </ng-container>
            <ng-container matColumnDef="AccessionNumber">
              <th mat-header-cell class="table-header" *matHeaderCellDef>AN</th>
              <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.AccessionNumber }}
              </td>
            </ng-container>
          </table>

          <table
            *ngIf="hasAditional"
            class="full-width margin-top-medium"
            mat-table
            [dataSource]="dataSourceAditional"
          >
            <tr
              mat-header-row
              class="table-header"
              *matHeaderRowDef="displayColumnsAditional"
            ></tr>
            <tr
              class="table-cell"
              mat-row
              *matRowDef="
                let row;
                let i = index;
                columns: displayColumnsAditional
              "
            ></tr>
            <ng-container matColumnDef="PracticeRegionAditionalName">
              <th mat-header-cell class="table-header" *matHeaderCellDef>
                Adicional
              </th>
              <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.PracticeRegionAditionalName }}
              </td>
            </ng-container>
          </table>

          <table
            *ngIf="hasSetSupplie"
            class="full-width margin-top-medium"
            mat-table
            [dataSource]="dataSourceSetSupplie"
          >
            <tr
              mat-header-row
              class="table-header"
              *matHeaderRowDef="displayColumnsSetSupplie"
            ></tr>
            <tr
              class="table-cell"
              mat-row
              *matRowDef="
                let row;
                let i = index;
                columns: displayColumnsSetSupplie
              "
            ></tr>
            <ng-container matColumnDef="SetSupplieName">
              <th mat-header-cell class="table-header" *matHeaderCellDef>
                Set insumo
              </th>
              <td mat-cell class="table-cell" *matCellDef="let element">
                {{ element.SetSupplieName }}
              </td>
            </ng-container>
          </table>
        </div>
      </div>

      <div class="card-box-medium">
        <h4>Detalle</h4>
        <mat-divider></mat-divider>
        <span *ngIf="!validMedicalOrderState" style="color: red"
          >Orden o documentación incompleta</span
        ><span
          *ngIf="!validMedicalOrderState && !validMedicalOrderAmount"
          style="color: red"
        >
          / </span
        ><span *ngIf="!validMedicalOrderAmount" style="color: red"
          >Cobranza pendiente</span
        >

        <form
          class="full-width margin-top-medium"
          [formGroup]="medicalServiceCareForm"
        >
          <div class="card-inline margin-botton-small">
            <mat-slide-toggle
              class="margin-right-medium"
              formControlName="CdDelivery"
              >Entrega CD</mat-slide-toggle
            >
            <mat-slide-toggle
              class="margin-right-medium"
              formControlName="PlatesDelivery"
              >Entrega placas</mat-slide-toggle
            >
            <mat-slide-toggle
              class="margin-right-medium"
              formControlName="PreviousStudies"
              >Estudios previos</mat-slide-toggle
            >
            <mat-slide-toggle
              class="margin-right-medium"
              formControlName="IsInternation"
              >Internado</mat-slide-toggle
            >

            <div>
              <button
                [disabled]="uploading"
                class="margin-right-medium full-width"
                (click)="fileInput.click()"
                mat-mini-fab
              >
                <mat-icon>add_a_photo</mat-icon>
                <input
                  [style.display]="hideElement ? 'none' : 'inherit'"
                  accept="image/*"
                  capture
                  type="file"
                  #fileInput
                  (change)="uploadFile($event.target.files)"
                />
              </button>

              <button
                class="margin-right-medium full-width"
                (click)="openPreviusStudiesShowDialog()"
                mat-mini-fab
              >
                <mat-icon>photo_album</mat-icon>
              </button>

              <button
                class="margin-right-medium full-width"
                (click)="medicalRecordPublish()"
                mat-mini-fab
              >
                <mat-icon>receipt</mat-icon>
              </button>
            </div>
          </div>
          <mat-form-field class="full-width">
            <mat-label>Cantidad estudios previos</mat-label>
            <input
              type="number"
              formControlName="PreviousStudiesAmount"
              min="1"
              matInput
            />
          </mat-form-field>
          <mat-form-field class="full-width">
            <mat-label>Cantidad placas</mat-label>
            <input
              type="number"
              formControlName="PlatesAmount"
              min="1"
              matInput
            />
          </mat-form-field>
          <mat-form-field class="full-width">
            <textarea
              matInput
              formControlName="PreviousStudiesDetails"
              placeholder="Detalle estudios anteriores"
            ></textarea>
          </mat-form-field>

          <app-previus-studies-links-control
            *ngIf="medicalAppointmentId"
            [appointmentId]="medicalAppointmentId"
          ></app-previus-studies-links-control>

          <mat-form-field class="full-width">
            <textarea
              matInput
              formControlName="ProcedureState"
              placeholder="Estado procedimiento"
            ></textarea>
          </mat-form-field>
          <mat-form-field class="full-width">
            <mat-label>Estado Fotografiado</mat-label>
            <mat-select formControlName="StatusPhotography">
              <mat-option
                *ngFor="let statusPhotography of statusPhotographies"
                [value]="statusPhotography"
              >
                {{ statusPhotography.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-button (click)="openClinicaDataRecordEdit()">
            Datos clínicos y Antecedentes
          </button>
          <button mat-button (click)="openCommentaryPreStudyEdit()">
            Comentarios y Preinforme
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
